import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function AdminLeaveApplications() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.leaveApproval === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [leaveData, setLeaveData] = useState([]);

  // fetch leave applications
  async function getLeave() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/leave/get/all`,
        method: "get",
        withCredentials: true,
      });
      //   console.log(res.data?.data);
      setLeaveData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave application fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getLeave();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Leave Approval
          </h1>
          <div className="w-full mt-5 flex justify-end items-end">
            <section className="w-auto flex items-center gap-3">
              <TextField label="Search" size="small" />
              <ButtonCompo variant={"contained"}>Search</ButtonCompo>
            </section>
          </div>
          <div className="mt-5 w-full">
            <Table>
              <TableHead>
                <TableRow className="bg-blue-500">
                  <TableCell className="!text-white !text-center">
                    Employee ID
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Applicant
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Role
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    From
                  </TableCell>
                  <TableCell className="!text-white !text-center">To</TableCell>
                  <TableCell className="!text-white !text-center">
                    Total Days
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Status
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    View
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="border">
                {leaveData?.map((e, i) => (
                  <TableRow key={i}>
                    <TableCell className="!text-center">
                      <span className="text-[13px] px-3 py-1 bg-blue-200/40 border-blue-300 border text-blue-700 font-medium rounded-full">
                        {e?.user?.employeeId}
                      </span>
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.user?.fullName}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.user?.role}
                    </TableCell>
                    <TableCell className="!text-center">{`${e?.startDom}-${
                      Number(e?.startMonth) + 1
                    }-${e?.startYear}`}</TableCell>
                    <TableCell className="!text-center">{`${e?.endDom}-${
                      Number(e?.endMonth) + 1
                    }-${e?.endYear}`}</TableCell>
                    <TableCell className="!text-center">
                      {e?.totalDays}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.isApproved === undefined ? (
                        <span className="text-[13px] px-3 py-1 bg-yellow-200/40 border-yellow-300 border text-yellow-700 font-medium rounded-full">
                          Pending
                        </span>
                      ) : e?.isApproved === true ? (
                        <span className="text-[13px] px-3 py-1 bg-green-200/40 border-green-300 border text-green-700 font-medium rounded-full">
                          Approved
                        </span>
                      ) : e?.isRevoked === true ? (
                        <span className="text-[13px] px-3 py-1 bg-red-200/40 border-red-300 border text-red-700 font-medium rounded-full">
                          Revoked
                        </span>
                      ) : (
                        <span className="text-[13px] px-3 py-1 bg-red-200/40 border-red-300 border text-red-700 font-medium rounded-full">
                          Rejected
                        </span>
                      )}
                    </TableCell>
                    <TableCell className="!text-center">
                      <ButtonCompo
                        variant={"contained"}
                        href={`/admin/leave/application/${e?._id}`}
                      >
                        View
                      </ButtonCompo>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminLeaveApplications;
